import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import { routes } from "../General";
import axios from "axios";
import { Liquidacion } from "./compModal/Liquidacion";
import { Documentos } from "./compModal/Documentos";
import { Facturas } from "./compModal/Facturas";
import { Contratante } from "./Contratante";
import { app } from "../../util/General";
import { DocsDigitalTabla } from "./DocsDigitalTabla";
import { Historial } from "../../coms/siniestros/Historial";
import { DeducibleAccordion } from "./compModal/DeducibleAccordion";
import { FormularioZoho } from "../zoho/FormularioZoho";

export class DetallesVAM extends Component {
    constructor(props) {
        super(...arguments);
        this.alert = React.createRef();
        this.state = {
            value: "",
            editing: false,
            item: {},
            cliente: {},
            hTabs: "ht0",
            beneficios: [],
            documentos: [],
            facturas: [],
            docdigital: [],
            docminio: [],
            liquidaciones: [],
            credHospitalario: [],
            totalesBeneficio: [],
            deducible: {
                total: 1,
                saldo: 1,
                consumido: 0,
            },
            diasExtra: null,
            historial: [],
            dueDate: "",
            createdTime: "",
        };
    }

    componentDidUpdate(prevProps) {
        let { open } = this.props;
        let openOld = prevProps.open;

        if (open !== openOld) {
            if (open) {
                this.fetchData();
            } else {
                this.setState({ item: {} });
            }
        }
    }

    onClose = () => {
        this.getDocDigital(this.props.siniestro);
    };

    fetchData() {
        this.getDeducibles(this.props.siniestro.cdCompania, this.props.siniestro.cdAsegurado);
        this.getBeneficios(this.props.siniestro.cdCompania, this.props.siniestro.cdIncSiniestro);
        this.getDocumentos(this.props.siniestro.cdCompania, this.props.siniestro.cdIncSiniestro);
        this.getFacturas(this.props.siniestro.cdCompania, this.props.siniestro.cdIncSiniestro);
        this.getLiquidaciones(this.props.siniestro.cdCompania, this.props.siniestro.cdIncSiniestro);
        this.getDocDigital(this.props.siniestro);
        this.getPoliza();

        let isAm = this.props.siniestro.nmRamo.toLowerCase().indexOf("med") >= 0;

        if (isAm && app.prodeseg) {
            this.getZohoDias();
        }
    }

    getBeneficios = (idComp, cdIncSiniestro) => {
        axios
            .get(routes.api + "/siniestros-vam/cobertura", {
                params: {
                    cdCompania: idComp,
                    cdIncSiniestro: cdIncSiniestro,
                },
            })
            .then(resp => {
                let bens = resp.data.sort((a1, a2) => a1.cdCobDedSiniestro - a2.cdCobDedSiniestro);

                let totales = {
                    valSiniestro: 0,
                    valExceso: 0,
                    valNoelegible: 0,
                    valCubierto: 0,
                    valDeducible: 0,
                    valFijo: 0,
                };
                bens.forEach(item => {
                    item.valCubierto = item.valSiniestro - item.valMinimo;
                    totales.valSiniestro += item.valSiniestro ? item.valSiniestro : 0;
                    totales.valExceso += item.valExceso ? item.valExceso : 0;
                    totales.valNoelegible += item.valNoelegible ? item.valNoelegible : 0;
                    totales.valCubierto += item.valCubierto ? item.valCubierto : 0;
                    totales.valDeducible += item.valDeducible ? item.valDeducible : 0;
                    totales.valFijo += item.valFijo ? item.valFijo : 0;
                });
                this.setState({ beneficios: bens, totalesBeneficio: totales });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getDocDigital = coti => {
        axios
            .get(routes.api + "/docs", {
                params: {
                    tipo: "siniestroVam",
                    numSiniestro: coti.numSiniestro + "." + coti.item + "/" + coti.anoSiniestro,
                    cdCliente: coti.cdCliente,
                    cdPoliza: coti.poliza,
                    cdCompania: coti.cdCompania,
                    cdReclamo: coti.cdReclamo,
                    cdIncSiniestro: coti.cdIncSiniestro,
                },
            })
            .then(resp => {
                let res = resp.data;
                res.minio.map(rp => {
                    rp.metadato = JSON.stringify(rp.metadato);
                });
                this.setState({ docminio: res.minio });
                (res.minio || []).forEach(datosTabla => {
                    datosTabla.metadato = JSON.parse(datosTabla.metadato);
                    //Se encuentra doble serializado el JSON
                    datosTabla.metadato = JSON.parse(datosTabla.metadato);
                });
                this.setState({ docdigital: res });
            })
            .catch(error => {
                console.log(" ERROR consultando doc digital :: ", error);
                // alert('Error al consultar' + error);
            });
    };

    getDocumentos = (idComp, cdIncSiniestro) => {
        axios
            .get(routes.api + "/siniestros-vam/cargarDocs", {
                params: {
                    cdCompania: idComp,
                    cdIncSiniestro: cdIncSiniestro,
                },
            })
            .then(resp => {
                let docs = resp.data.sort((a1, a2) => parseInt(a1.item) - parseInt(a2.item));
                this.setState({ documentos: docs });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getFacturas = (idComp, cdIncSiniestro) => {
        axios
            .get(routes.api + "/siniestros-vam/cargarFactura", {
                params: {
                    cdCompania: idComp,
                    cdIncSiniestro: cdIncSiniestro,
                },
            })
            .then(resp => {
                let facts = resp.data;
                this.setState({ facturas: facts });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getLiquidaciones = (idComp, cdIncSiniestro) => {
        axios
            .get(routes.api + "/siniestros-vam/cargarLiquidacion", {
                params: {
                    cdCompania: idComp,
                    cdIncSiniestro: cdIncSiniestro,
                },
            })
            .then(resp => {
                let liqs = resp.data;
                this.setState({ liquidaciones: liqs });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getDeducibles = (cdCompania, cdAsegurado) => {
        axios
            .get(routes.api + "/siniestros-vam/deducible", {
                params: { cdCompania, cdAsegurado },
            })
            .then(resp => {
                let deducible = resp.data;
                this.setState({ deducible });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getCredHospitalario = (cdCompania, cdIncSiniestro) => {
        axios
            .get(routes.api + "/siniestros-vam/credhosp", {
                params: { cdCompania, cdIncSiniestro },
            })
            .then(resp => {
                let cred = resp.data;
                this.setState({ cred });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    closeModal = () => {
        this.props.toggleModal(false);
        this.setState({ item: {} });
        this.setState({ historial: [] });
        this.setState({ dueDate: "" });
    };

    tabSelect = tab => {
        this.setState({ hTabs: tab });
    };

    getPoliza = () => {
        axios
            .get(routes.api + "" + "/cliente", {
                params: {
                    cdCliente: this.props.siniestro.cdCliente,
                },
            })
            .then(resp => {
                this.setState({ cliente: resp.data });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getZohoDias = () => {
        let cdIncSiniestro = this.props.siniestro.cdIncSiniestro;
        let cdCompania = this.props.siniestro.cdCompania;
        let numReclamo = this.props.siniestro.numSiniestro + "." + this.props.siniestro.item;
        let anio = this.props.siniestro.anoSiniestro;
        let estado = this.props.siniestro.estado || "-";

        axios
            .post(routes.apiVam + "/zohoDiasMsg", { cdIncSiniestro, cdCompania, numReclamo, anio, estado })
            .then(resp => {
                let tmp = resp.data;
                this.setState({ diasExtra: tmp });
                this.setState({ dueDate: tmp.dueDate });
                this.setState({ createdTime: tmp.createdTime });
                let ht = tmp.historial; //debo ordenar esto
                if (ht) {
                    ht.sort(function (a, b) {
                        return new Date(a.fecha) - new Date(b.fecha);
                    });
                    this.setState({ historial: ht });
                } else {
                    this.setState({ historial: [] });
                }
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    render() {
        return (
            <Modal className="text-center modal-xl mx-auto modal-detail modal-siniestros" isOpen={this.props.open}>
                <ModalBody>
                    <div className="row">
                        <Contratante
                            siniestro={this.props.siniestro}
                            cliente={this.state.cliente}
                            alert={this.alert.current}
                            diasExtra={this.state.diasExtra}
                            dueDate={this.state.dueDate}
                            liquidacion={this.state.liquidaciones}
                        />
                        <div className="col-lg-9 pt-2">
                            <div className={"text-right"}>
                                <button
                                    type="button"
                                    className="close"
                                    title="Cerrar"
                                    onClick={() => {
                                        this.closeModal();
                                    }}
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <h5 className="card-title">Detalle Siniestro</h5>
                            <DeducibleAccordion hTabs={this.state.hTabs} deducibles={this.state.deducible} />
                            <div className="my-1" />
                            <div className="my-1" />
                            <Facturas hTabs={this.state.hTabs} facturas={this.state.facturas} vam={true} />
                            <div className="my-1" />
                            <Liquidacion hTabs={this.state.hTabs} liquidaciones={this.state.liquidaciones} />
                            <div className="my-1" />
                            <DocsDigitalTabla
                                hTabs={this.state.hTabs}
                                docdigital={this.state.docdigital}
                                docminio={this.state.docminio}
                                tipo={"siniestroVam"}
                                dato={this.props.siniestro}
                                onClose={this.onClose}
                            />
                            <div className="my-1" />
                            <Historial
                                historial={this.state.historial}
                                fecha={this.state.dueDate}
                                aseguradora={this.props.siniestro.nmAseguradora}
                                creacionFc={this.state.createdTime}
                                siniestro={this.props.siniestro}
                                zohoFormItem={FormularioZoho}
                                dato={this.props.siniestro}
                                tipo={"siniestroVam"}
                                onClose={this.onClose}
                            />
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}
